import { Button } from 'grommet';
import { Upload } from 'grommet-icons';

const UploadButton = ({ setView }) => {
    return (
        <Button
            icon={<Upload />}
            onClick={() => {
                setView('upload');
            }}
        />
    )
}

export default UploadButton;